import React, { useState } from 'react';

export const EntryContext = React.createContext({ entry: null, setEntry: () => {} });

const defaultEntry = {
    ticketData: null,
    entryId: 0,
    prizeType: null,
    nearWin: 0,
    gamePlayed: 0,
    revealType: 0,
};

const defaultCredentials = {
    jurisdiction: null,
    credentials: {},
    ticket: null,
    numeric_code: null,
};

export const EntryProvider = ({ children }) => {
    const [entry, setEntry] = useState(defaultEntry);

    const [credentials, setCredentails] = useState(defaultCredentials);

    const [siteAssets, setSiteAssets] = useState(null);
    const [game, setGame] = useState(null);
    const [revealGames, setRevealGames] = useState(null);
    const [cmsVersion, setCmsVersion] = useState(null);

    const [igrAuthToken, setIgrAuthToken] = useState(null);
    const [igrGameUrl, setIgrGameUrl] = useState(null);

    const [selectedRevealGame, setSelectedRevealGame] = useState(null);

    const [accessibility, setAccessibility] = useState(0);

    const [errorCode, setErrorCode] = useState(null);

    const [loading, setLoading] = useState(false);

    //? For debug: console.log('EntryProvider: 🏪', { entry, credentials, siteAssets, game, revealGames, igrAuthToken, igrGameUrl, selectedRevealGame, accessibility, loading });

    return (
        <EntryContext.Provider
            value={{
                entry,
                setEntry,
                credentials,
                setCredentails,
                igrAuthToken,
                setIgrAuthToken,
                siteAssets,
                setSiteAssets,
                game,
                setGame,
                revealGames,
                setRevealGames,
                cmsVersion,
                setCmsVersion,
                igrGameUrl,
                setIgrGameUrl,
                selectedRevealGame,
                setSelectedRevealGame,
                accessibility,
                setAccessibility,
                errorCode,
                setErrorCode,
                loading,
                setLoading,
            }}>
            {children}
        </EntryContext.Provider>
    );
};
